import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => {
  const lang = localStorage.getItem("lang") || "en";
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "Accept-Language": lang,
  };
};

export const getPurchaseOrderReport = async (params = {}) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/purchase-order-report/list`,
      {
        headers: getAuthHeaders(),
        params,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get Purchase Order Report API Error:", error);
    throw (
      error?.response?.data || {
        message: "Failed to fetch purchase order report",
      }
    );
  }
};

export const getPurchaseOrderReportSummary = async (params = {}) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/purchase-order-report/summary`,
      {
        headers: getAuthHeaders(),
        params,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get Purchase Order Report Summary API Error:", error);
    throw (
      error?.response?.data || {
        message: "Failed to fetch purchase order report summary",
      }
    );
  }
};

export const downloadPurchaseOrderReportExcel = async (params = {}) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/purchase-order-report/download/excel`,
      {
        headers: getAuthHeaders(),
        params,
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "purchase-order-report.xlsx";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Download Purchase Order Report Excel API Error:", error);
    throw (
      error?.response?.data || {
        message: "Failed to download excel report",
      }
    );
  }
};

export const downloadPurchaseOrderReportPdf = async (params = {}) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/purchase-order-report/download/pdf`,
      {
        headers: getAuthHeaders(),
        params,
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "purchase-order-report.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Download Purchase Order Report PDF API Error:", error);
    throw (
      error?.response?.data || {
        message: "Failed to download pdf report",
      }
    );
  }
};

export const mapPurchaseOrderReportRow = (row) => {
  return {
    key: row?.key || row?.productId,
    productId: row?.productId || "",
    productName: row?.productName || "-",
    img: row?.image || "",
    sku: row?.sku || "",
    itemCode: row?.itemCode || "",
    productAmount: Number(row?.productAmount || 0),
    productAmountLabel: `$${Number(row?.productAmount || 0).toFixed(2)}`,
    productQty: Number(row?.productQty || 0),
    instockQty: Number(row?.instockQty || 0),
    purchaseCount: Number(row?.purchaseCount || 0),
    lastPurchaseDate: row?.lastPurchaseDate || null,
    raw: row,
  };
};